export default "__VITE_ASSET__BWYihgXG__"